import { Fragment, useState } from "react";
import { ChevronsRight } from "react-feather";
import { Btn, H6, P } from "../../../../AbstractElements";
import { ExtraLargeModal } from "../../../../Constants/Constants";
import { FullScreenModalData } from "../../../../Data/UiKits/Modal";
import CommonModal from "../Common/CommonModal";

const ExtraLarge = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {isOpen: modal,header: true,toggler: toggle,title: "Extra large modal",size: "xl",bodyClass: "dark-modal"};
  return (
    <Fragment>
      <Btn color="info" onClick={toggle}>{ExtraLargeModal}</Btn>
      <CommonModal modalData={data}>
        {FullScreenModalData &&
          FullScreenModalData.map((item, index) => (
            <Fragment key={index}>
              <div className="large-modal-header">
                <ChevronsRight />
                <H6>{item.title}</H6>
              </div>
              <P className="modal-padding-space">{item.text}</P>
            </Fragment>
          ))}
      </CommonModal>
    </Fragment>
  );
};
export default ExtraLarge;
